import { computed, type defineComponent, onBeforeMount, ref, watch } from 'vue'
import api from '@/services/api'
import type { Achievement, AchievementItem } from '@/types/achievements'
import { AchievementType } from '@/types/achievements'
import CalendarBronzeIcon from '@/assets/images/achievements/calendar-bronze.png'
import CalendarSilverIcon from '@/assets/images/achievements/calendar-silver.png'
import CalendarGoldIcon from '@/assets/images/achievements/calendar-gold.png'
import Calendar1Icon from '@/assets/images/achievements/calendar1.png'
import Calendar2Icon from '@/assets/images/achievements/calendar2.png'
import Calendar3Icon from '@/assets/images/achievements/calendar3.png'
import Calendar4Icon from '@/assets/images/achievements/calendar4.png'
import Calendar5Icon from '@/assets/images/achievements/calendar5.png'
import Calendar6Icon from '@/assets/images/achievements/calendar6.png'
import Calendar7Icon from '@/assets/images/achievements/calendar7.png'
import Calendar8Icon from '@/assets/images/achievements/calendar8.png'
import Calendar9Icon from '@/assets/images/achievements/calendar9.png'
import Calendar10Icon from '@/assets/images/achievements/calendar10.png'
import Calendar11Icon from '@/assets/images/achievements/calendar11.png'
import CardsBronzeIcon from '@/assets/images/achievements/cards-bronze.png'
import CardsSilverIcon from '@/assets/images/achievements/cards-silver.png'
import CardsGoldIcon from '@/assets/images/achievements/cards-gold.png'
import Cards1Icon from '@/assets/images/achievements/cards1.png'
import Cards2Icon from '@/assets/images/achievements/cards2.png'
import Cards3Icon from '@/assets/images/achievements/cards3.png'
import Cards4Icon from '@/assets/images/achievements/cards4.png'
import Cards5Icon from '@/assets/images/achievements/cards5.png'
import Cards6Icon from '@/assets/images/achievements/cards6.png'
import Cards7Icon from '@/assets/images/achievements/cards7.png'
import Cards8Icon from '@/assets/images/achievements/cards8.png'
import Cards9Icon from '@/assets/images/achievements/cards9.png'
import Cards10Icon from '@/assets/images/achievements/cards10.png'
import Cards11Icon from '@/assets/images/achievements/cards11.png'
import Cards12Icon from '@/assets/images/achievements/cards12.png'
import Cards13Icon from '@/assets/images/achievements/cards13.png'
import Cards14Icon from '@/assets/images/achievements/cards14.png'
import Cards15Icon from '@/assets/images/achievements/cards15.png'
import ClockBronzeIcon from '@/assets/images/achievements/clock-bronze.png'
import ClockSilverIcon from '@/assets/images/achievements/clock-silver.png'
import ClockGoldIcon from '@/assets/images/achievements/clock-gold.png'
import Clock1Icon from '@/assets/images/achievements/clock1.png'
import Clock2Icon from '@/assets/images/achievements/clock2.png'
import Clock3Icon from '@/assets/images/achievements/clock3.png'
import Clock4Icon from '@/assets/images/achievements/clock4.png'
import Clock5Icon from '@/assets/images/achievements/clock5.png'
import Clock6Icon from '@/assets/images/achievements/clock6.png'
import Clock7Icon from '@/assets/images/achievements/clock7.png'
import Clock8Icon from '@/assets/images/achievements/clock8.png'
import Clock9Icon from '@/assets/images/achievements/clock9.png'
import Clock10Icon from '@/assets/images/achievements/clock10.png'
import Clock11Icon from '@/assets/images/achievements/clock11.png'
import Clock12Icon from '@/assets/images/achievements/clock12.png'
import Clock13Icon from '@/assets/images/achievements/clock13.png'
import Clock14Icon from '@/assets/images/achievements/clock14.png'
import Clock15Icon from '@/assets/images/achievements/clock15.png'
import Clock16Icon from '@/assets/images/achievements/clock16.png'
import Clock17Icon from '@/assets/images/achievements/clock17.png'
import DatabaseServerBronzeIcon from '@/assets/images/achievements/database-server-bronze.png'
import DatabaseServerSilverIcon from '@/assets/images/achievements/database-server-silver.png'
import DatabaseServerGoldIcon from '@/assets/images/achievements/database-server-gold.png'
import DatabaseServer1Icon from '@/assets/images/achievements/database-server1.png'
import DatabaseServer2Icon from '@/assets/images/achievements/database-server2.png'
import DatabaseServer3Icon from '@/assets/images/achievements/database-server3.png'
import DatabaseServer4Icon from '@/assets/images/achievements/database-server4.png'
import DatabaseServer5Icon from '@/assets/images/achievements/database-server5.png'
import DatabaseServer6Icon from '@/assets/images/achievements/database-server6.png'
import DatabaseServer7Icon from '@/assets/images/achievements/database-server7.png'
import DatabaseServer8Icon from '@/assets/images/achievements/database-server8.png'
import DatabaseServer9Icon from '@/assets/images/achievements/database-server9.png'
import DatabaseServer10Icon from '@/assets/images/achievements/database-server10.png'
import DatabaseServer11Icon from '@/assets/images/achievements/database-server11.png'
import PortfolioBronzeIcon from '@/assets/images/achievements/portfolio-bronze.png'
import PortfolioSilverIcon from '@/assets/images/achievements/portfolio-silver.png'
import PortfolioGoldIcon from '@/assets/images/achievements/portfolio-gold.png'
import Portfolio1Icon from '@/assets/images/achievements/portfolio1.png'
import Portfolio2Icon from '@/assets/images/achievements/portfolio2.png'
import Portfolio3Icon from '@/assets/images/achievements/portfolio3.png'
import Portfolio4Icon from '@/assets/images/achievements/portfolio4.png'
import Portfolio5Icon from '@/assets/images/achievements/portfolio5.png'
import Portfolio6Icon from '@/assets/images/achievements/portfolio6.png'
import Portfolio7Icon from '@/assets/images/achievements/portfolio7.png'
import Portfolio8Icon from '@/assets/images/achievements/portfolio8.png'
import Portfolio9Icon from '@/assets/images/achievements/portfolio9.png'
import Portfolio10Icon from '@/assets/images/achievements/portfolio10.png'
import Portfolio11Icon from '@/assets/images/achievements/portfolio11.png'
import Portfolio12Icon from '@/assets/images/achievements/portfolio12.png'
import UsersBronzeIcon from '@/assets/images/achievements/users-bronze.png'
import UsersSilverIcon from '@/assets/images/achievements/users-silver.png'
import UsersGoldIcon from '@/assets/images/achievements/users-gold.png'
import Users1Icon from '@/assets/images/achievements/users1.png'
import Users2Icon from '@/assets/images/achievements/users2.png'
import Users3Icon from '@/assets/images/achievements/users3.png'
import Users4Icon from '@/assets/images/achievements/users4.png'
import Users5Icon from '@/assets/images/achievements/users5.png'
import Users6Icon from '@/assets/images/achievements/users6.png'
import Users7Icon from '@/assets/images/achievements/users7.png'
import Users8Icon from '@/assets/images/achievements/users8.png'
import Users9Icon from '@/assets/images/achievements/users9.png'
import Users10Icon from '@/assets/images/achievements/users10.png'
import Users11Icon from '@/assets/images/achievements/users11.png'
import Users12Icon from '@/assets/images/achievements/users12.png'
import WheelBronzeIcon from '@/assets/images/achievements/wheel-bronze.png'
import WheelSilverIcon from '@/assets/images/achievements/wheel-silver.png'
import WheelGoldIcon from '@/assets/images/achievements/wheel-gold.png'
import Wheel1Icon from '@/assets/images/achievements/wheel1.png'
import Wheel2Icon from '@/assets/images/achievements/wheel2.png'
import Wheel3Icon from '@/assets/images/achievements/wheel3.png'
import Wheel4Icon from '@/assets/images/achievements/wheel4.png'
import Wheel5Icon from '@/assets/images/achievements/wheel5.png'
import Wheel6Icon from '@/assets/images/achievements/wheel6.png'
import Wheel7Icon from '@/assets/images/achievements/wheel7.png'
import Wheel8Icon from '@/assets/images/achievements/wheel8.png'
import Wheel9Icon from '@/assets/images/achievements/wheel9.png'
import Wheel10Icon from '@/assets/images/achievements/wheel10.png'
import Wheel11Icon from '@/assets/images/achievements/wheel11.png'
import Wheel12Icon from '@/assets/images/achievements/wheel12.png'
import Wheel13Icon from '@/assets/images/achievements/wheel13.png'
import Wheel14Icon from '@/assets/images/achievements/wheel14.png'
import TxBronzeIcon from '@/assets/images/achievements/tx-bronze.png'
import TxSilverIcon from '@/assets/images/achievements/tx-silver.png'
import TxGoldIcon from '@/assets/images/achievements/tx-gold.png'
import Tx1Icon from '@/assets/images/achievements/tx1.png'
import Tx2Icon from '@/assets/images/achievements/tx2.png'
import Tx3Icon from '@/assets/images/achievements/tx3.png'
import Tx4Icon from '@/assets/images/achievements/tx4.png'
import Tx5Icon from '@/assets/images/achievements/tx5.png'
import Tx6Icon from '@/assets/images/achievements/tx6.png'
import Tx7Icon from '@/assets/images/achievements/tx7.png'
import Tx8Icon from '@/assets/images/achievements/tx8.png'
import Tx9Icon from '@/assets/images/achievements/tx9.png'
import Tx10Icon from '@/assets/images/achievements/tx10.png'
import Tx11Icon from '@/assets/images/achievements/tx11.png'
import Tx12Icon from '@/assets/images/achievements/tx12.png'
import PathwayBronzeIcon from '@/assets/images/achievements/pathway-bronze.png'
import PathwaySilverIcon from '@/assets/images/achievements/pathway-silver.png'
import PathwayGoldIcon from '@/assets/images/achievements/pathway-gold.png'
import Pathway1Icon from '@/assets/images/achievements/pathway1.png'
import Pathway2Icon from '@/assets/images/achievements/pathway2.png'
import Pathway3Icon from '@/assets/images/achievements/pathway3.png'
import Pathway4Icon from '@/assets/images/achievements/pathway4.png'
import Pathway5Icon from '@/assets/images/achievements/pathway5.png'
import Pathway6Icon from '@/assets/images/achievements/pathway6.png'
import Pathway7Icon from '@/assets/images/achievements/pathway7.png'
import Pathway8Icon from '@/assets/images/achievements/pathway8.png'
import Pathway9Icon from '@/assets/images/achievements/pathway9.png'
import Pathway10Icon from '@/assets/images/achievements/pathway10.png'
import Pathway11Icon from '@/assets/images/achievements/pathway11.png'
import BoxBronzeIcon from '@/assets/images/achievements/box-bronze.png'
import BoxSilverIcon from '@/assets/images/achievements/box-silver.png'
import BoxGoldIcon from '@/assets/images/achievements/box-gold.png'
import Box1Icon from '@/assets/images/achievements/box1.png'
import Box2Icon from '@/assets/images/achievements/box2.png'
import Box3Icon from '@/assets/images/achievements/box3.png'
import Box4Icon from '@/assets/images/achievements/box4.png'
import Box5Icon from '@/assets/images/achievements/box5.png'
import Box6Icon from '@/assets/images/achievements/box6.png'
import Box7Icon from '@/assets/images/achievements/box7.png'
import Box8Icon from '@/assets/images/achievements/box8.png'
import Box9Icon from '@/assets/images/achievements/box9.png'
import Box10Icon from '@/assets/images/achievements/box10.png'
import Box11Icon from '@/assets/images/achievements/box11.png'
import Box12Icon from '@/assets/images/achievements/box12.png'
import BookmarkBronzeIcon from '@/assets/images/achievements/bookmark-bronze.png'
import BookmarkSilverIcon from '@/assets/images/achievements/bookmark-silver.png'
import BookmarkGoldIcon from '@/assets/images/achievements/bookmark-gold.png'
import Bookmark1Icon from '@/assets/images/achievements/bookmark1.png'
import Bookmark2Icon from '@/assets/images/achievements/bookmark2.png'
import Bookmark3Icon from '@/assets/images/achievements/bookmark3.png'
import Bookmark4Icon from '@/assets/images/achievements/bookmark4.png'
import Bookmark5Icon from '@/assets/images/achievements/bookmark5.png'
import Bookmark6Icon from '@/assets/images/achievements/bookmark6.png'
import Bookmark7Icon from '@/assets/images/achievements/bookmark7.png'
import Bookmark8Icon from '@/assets/images/achievements/bookmark8.png'
import Bookmark9Icon from '@/assets/images/achievements/bookmark9.png'
import Bookmark10Icon from '@/assets/images/achievements/bookmark10.png'
import Bookmark11Icon from '@/assets/images/achievements/bookmark11.png'
import Bookmark12Icon from '@/assets/images/achievements/bookmark12.png'
import Bookmark13Icon from '@/assets/images/achievements/bookmark13.png'
import PathwayStepBronzeIcon from '@/assets/images/achievements/pathway-step-bronze.png'
import PathwayStepSilverIcon from '@/assets/images/achievements/pathway-step-silver.png'
import PathwayStepGoldIcon from '@/assets/images/achievements/pathway-step-gold.png'
import PathwayStep1Icon from '@/assets/images/achievements/pathway-step1.png'
import PathwayStep2Icon from '@/assets/images/achievements/pathway-step2.png'
import PathwayStep3Icon from '@/assets/images/achievements/pathway-step3.png'
import PathwayStep4Icon from '@/assets/images/achievements/pathway-step4.png'
import PathwayStep5Icon from '@/assets/images/achievements/pathway-step5.png'
import PathwayStep6Icon from '@/assets/images/achievements/pathway-step6.png'
import PathwayStep7Icon from '@/assets/images/achievements/pathway-step7.png'
import PathwayStep8Icon from '@/assets/images/achievements/pathway-step8.png'
import PathwayStep9Icon from '@/assets/images/achievements/pathway-step9.png'
import PathwayStep10Icon from '@/assets/images/achievements/pathway-step10.png'
import PathwayStep11Icon from '@/assets/images/achievements/pathway-step11.png'
import PathwayStep12Icon from '@/assets/images/achievements/pathway-step12.png'
import PathwayStep13Icon from '@/assets/images/achievements/pathway-step13.png'
import PathwayStep14Icon from '@/assets/images/achievements/pathway-step14.png'
import PathwayStep15Icon from '@/assets/images/achievements/pathway-step15.png'
import { StorageSerializers, useLocalStorage } from '@vueuse/core'
import { buildDropeeStorageKey } from '@/config/config'
import { useConfig } from '@/composables/game/config'
import { usePlayer } from '@/composables/game/player'
import { useBadges } from '@/composables/game/badge'
import { useFortuneWheel } from '@/composables/game/fortune-wheel'
import { formatNumberFullTruncate } from '@/helpers/utils'
import DailyComboTitleTooltip from '@/components/achievement-tooltips/DailyComboTitleTooltip.vue'
import PathwaysCompletedTitleTooltip from '@/components/achievement-tooltips/PathwaysCompletedTitleTooltip.vue'
import PathwayStepsCompletedTitleTooltip from '@/components/achievement-tooltips/PathwayStepsCompletedTitleTooltip.vue'

export const lastAchievements = useLocalStorage<Achievement | null>(buildDropeeStorageKey('player_achievements'), null, { serializer: StorageSerializers.object })
const achievements = ref<Achievement | null>(null)
const newlyAchievedMilestones = ref<Record<keyof Achievement, boolean>>({
  [AchievementType.DaysSinceOnboarding]: false,
  [AchievementType.DailyCheckinStreaks]: false,
  [AchievementType.CardsUpgrade]: false,
  [AchievementType.CardsAbove15]: false,
  [AchievementType.CardsAbove25]: false,
  [AchievementType.CardsAbove50]: false,
  [AchievementType.CardsAbove100]: false,
  [AchievementType.CardsAbove150]: false,
  [AchievementType.SpecialCards]: false,
  [AchievementType.Friends]: false,
  [AchievementType.Spins]: false,
  [AchievementType.Tasks]: false,
  [AchievementType.Badges]: false,
  [AchievementType.OnChainTransactions]: false,
  [AchievementType.Pathways]: false,
  [AchievementType.PathwaySteps]: false,
  [AchievementType.MysteryBoxes]: false,
  [AchievementType.DailyCombo]: false,
})

const isAchievementsOverlayDelayed = ref<boolean>(false)
const newAchievedMilestoneForOverlay = ref<null | { achievement: AchievementItem, categoryTitle: string }>()

export enum AchievementCategory {
  DropeeJourney = 'DropeeJourney',
  GameplayAndActivity = 'GameplayAndActivity',
  CardsMastery = 'CardsMastery',
  AdvancedPlay = 'AdvancedPlay',
  SpecialEvents = 'SpecialEvents',
  PlaySurge = 'PlaySurge',
}

export const achievementCategoryOrder: AchievementCategory[] = [
  AchievementCategory.DropeeJourney,
  AchievementCategory.GameplayAndActivity,
  AchievementCategory.CardsMastery,
  AchievementCategory.AdvancedPlay,
  AchievementCategory.SpecialEvents,
  AchievementCategory.PlaySurge,
]

export const achievementCategories: Record<AchievementType, {
  category: AchievementCategory,
  title: string,
  titleTooltipComponent?: string | ReturnType<typeof defineComponent>
  milestones: AchievementItem[],
  hidden?: boolean
  leftUntilNextMilestoneTooltip: (count: number) => string
}> = {
  [AchievementType.DaysSinceOnboarding]: {
    category: AchievementCategory.DropeeJourney,
    title: 'Days on Dropee',
    milestones: [
      {
        number: 1,
        icon: PortfolioBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 7,
        icon: PortfolioSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 15,
        icon: PortfolioGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 30,
        icon: Portfolio1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 60, icon: Portfolio2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 90,
        icon: Portfolio3Icon,
        percentage: 25,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 120,
        icon: Portfolio4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      {
        number: 150,
        icon: Portfolio5Icon,
        percentage: 9,
        tooltip: 'You’re among the top {percentage}! A true master!',
      },
      {
        number: 190,
        icon: Portfolio6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 220,
        icon: Portfolio7Icon,
        percentage: 1,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 250,
        icon: Portfolio8Icon,
      },
      {
        number: 300,
        icon: Portfolio9Icon,
      },
      {
        number: 350,
        icon: Portfolio10Icon,
      }, {
        number: 400,
        icon: Portfolio11Icon,
      },
      {
        number: 450,
        icon: Portfolio12Icon,
      },

    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'days' : 'day'}</span> left to unlock this achievement`,
  },
  [AchievementType.DailyCheckinStreaks]: {
    category: AchievementCategory.DropeeJourney,
    title: 'Daily check-in streaks (in days)',
    milestones: [
      {
        number: 5,
        icon: CalendarBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 10,
        icon: CalendarSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 25,
        icon: CalendarGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 50,
        icon: Calendar1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 100, icon: Calendar2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 120,
        icon: Calendar3Icon,
        percentage: 25,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 140,
        icon: Calendar4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 160, icon: Calendar5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 180,
        icon: Calendar6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 200,
        icon: Calendar7Icon,
        percentage: 1,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 250,
        icon: Calendar8Icon,
      },
      {
        number: 300,
        icon: Calendar9Icon,
      },
      {
        number: 350,
        icon: Calendar10Icon,
      },
      {
        number: 400,
        icon: Calendar11Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'days' : 'day'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsUpgrade]: {
    category: AchievementCategory.GameplayAndActivity,
    title: 'Cards upgraded',
    milestones: [
      {
        number: 10,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 100,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 250,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 650,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 1000, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 1350,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 1600,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 1900, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 2400,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 3000,
        icon: Cards7Icon,
        percentage: 1,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 5000,
        icon: Cards8Icon,
      },
      {
        number: 7500,
        icon: Cards9Icon,
      },
      {
        number: 10000,
        icon: Cards10Icon,
      },
      {
        number: 15000,
        icon: Cards11Icon,
      },
      {
        number: 20000,
        icon: Cards12Icon,
      },
      {
        number: 25000,
        icon: Cards13Icon,
      },
      {
        number: 30000,
        icon: Cards14Icon,
      },
      {
        number: 35000,
        icon: Cards15Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsAbove15]: {
    category: AchievementCategory.CardsMastery,
    title: 'Cards level 15 and above',
    milestones: [
      {
        number: 3,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 5,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 7,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 10,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 15, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 20,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!',
      },
      {
        number: 25,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 30, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 35,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 50,
        icon: Cards7Icon,
      },
      {
        number: 75,
        icon: Cards8Icon,
      },
      {
        number: 100,
        icon: Cards9Icon,
      },
      {
        number: 200,
        icon: Cards10Icon,
      },
      {
        number: 300,
        icon: Cards11Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsAbove25]: {
    category: AchievementCategory.CardsMastery,
    title: 'Cards level 25 and above',
    milestones: [
      {
        number: 1,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 2,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 3,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 4,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 5, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      { number: 6, icon: Cards3Icon, percentage: 25, tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!' },
      {
        number: 10,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 15, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 21,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      { number: 29, icon: Cards7Icon, percentage: 1, tooltip: 'Legendary status! You’re among the top {percentage}!' },
      { number: 50, icon: Cards8Icon },
      { number: 75, icon: Cards9Icon },
      { number: 100, icon: Cards10Icon },
      { number: 200, icon: Cards11Icon },
      { number: 300, icon: Cards12Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsAbove50]: {
    category: AchievementCategory.CardsMastery,
    title: 'Cards level 50 and above',
    milestones: [
      {
        number: 1,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 3,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 5,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 7,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 10, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 15,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!',
      },
      {
        number: 20,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 25, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 35,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      { number: 50, icon: Cards7Icon, percentage: 1, tooltip: 'Legendary status! You’re among the top {percentage}!' },
      { number: 75, icon: Cards8Icon },
      { number: 100, icon: Cards9Icon },
      { number: 150, icon: Cards10Icon },
      { number: 200, icon: Cards11Icon },
      { number: 250, icon: Cards12Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsAbove100]: {
    category: AchievementCategory.CardsMastery,
    title: 'Cards level 100 and above',
    milestones: [
      {
        number: 1,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 2,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 3,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 5,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 7, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 10,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!',
      },
      {
        number: 15,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 20, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 25,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      { number: 35, icon: Cards7Icon, percentage: 1, tooltip: 'Legendary status! You’re among the top {percentage}!' },
      { number: 50, icon: Cards8Icon },
      { number: 75, icon: Cards9Icon },
      { number: 100, icon: Cards10Icon },
      { number: 125, icon: Cards11Icon },
      { number: 150, icon: Cards12Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.CardsAbove150]: {
    category: AchievementCategory.CardsMastery,
    title: 'Cards level 150 and above',
    milestones: [
      {
        number: 1,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 2,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 3,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 5,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 7, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 10,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!',
      },
      {
        number: 15,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 20, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 25,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      { number: 35, icon: Cards7Icon, percentage: 1, tooltip: 'Legendary status! You’re among the top {percentage}!' },
      { number: 50, icon: Cards8Icon },
      { number: 75, icon: Cards9Icon },
      { number: 100, icon: Cards10Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.SpecialCards]: {
    category: AchievementCategory.GameplayAndActivity,
    title: 'Special cards',
    milestones: [
      {
        number: 1,
        icon: CardsBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 2,
        icon: CardsSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 3,
        icon: CardsGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 4,
        icon: Cards1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 5, icon: Cards2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 10,
        icon: Cards3Icon,
        percentage: 25,
        tooltip: 'Top quarter of Dropee’s finest! You’re climbing fast!',
      },
      {
        number: 13,
        icon: Cards4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 15, icon: Cards5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 17,
        icon: Cards6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      { number: 20, icon: Cards7Icon, percentage: 1, tooltip: 'Legendary status! You’re among the top {percentage}!' },
      { number: 25, icon: Cards8Icon },
      { number: 50, icon: Cards9Icon },
      { number: 75, icon: Cards10Icon },
      { number: 100, icon: Cards11Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'cards' : 'card'}</span> left to unlock this achievement`,
  },
  [AchievementType.DailyCombo]: {
    category: AchievementCategory.GameplayAndActivity,
    title: 'Daily Combo ',
    titleTooltipComponent: DailyComboTitleTooltip,
    milestones: [
      {
        number: 1,
        icon: BookmarkBronzeIcon,
      },
      {
        number: 7,
        icon: BookmarkSilverIcon,
      },
      {
        number: 15,
        icon: BookmarkGoldIcon,
      },
      {
        number: 30,
        icon: Bookmark1Icon,
      },
      { number: 60, icon: Bookmark2Icon },
      {
        number: 90,
        icon: Bookmark3Icon,
      },
      {
        number: 120,
        icon: Bookmark4Icon,
      },
      { number: 150, icon: Bookmark5Icon },
      {
        number: 190,
        icon: Bookmark6Icon,
      },
      { number: 220, icon: Bookmark7Icon },
      { number: 250, icon: Bookmark8Icon },
      { number: 275, icon: Bookmark9Icon },
      { number: 300, icon: Bookmark10Icon },
      { number: 350, icon: Bookmark11Icon },
      { number: 375, icon: Bookmark12Icon },
      { number: 400, icon: Bookmark13Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'combos' : 'combo'}</span> left to unlock this achievement`,
  },
  [AchievementType.Friends]: {
    category: AchievementCategory.DropeeJourney,
    title: 'Friends referred',
    milestones: [
      {
        number: 1,
        icon: UsersBronzeIcon,
        percentage: 95,
      },
      {
        number: 3,
        icon: UsersSilverIcon,
        percentage: 71,
      },
      {
        number: 5,
        icon: UsersGoldIcon,
        percentage: 64,
      },
      {
        number: 10,
        icon: Users1Icon,
        percentage: 49,
      },
      { number: 15, icon: Users2Icon, percentage: 36 },
      { number: 20, icon: Users3Icon, percentage: 25 },
      {
        number: 30,
        icon: Users4Icon,
        percentage: 16,
      },
      { number: 40, icon: Users5Icon, percentage: 9 },
      {
        number: 50,
        icon: Users6Icon,
        percentage: 4,
      },
      { number: 100, icon: Users7Icon, percentage: 1 },
      { number: 200, icon: Users8Icon },
      { number: 500, icon: Users9Icon },
      { number: 1000, icon: Users10Icon },
      { number: 1500, icon: Users11Icon },
      { number: 2000, icon: Users12Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `Get <span class="text-green-primary">${formatNumberFullTruncate(count)} new ${count > 1 ? 'friends' : 'friend'}</span> to join to unlock this achievement`,
  },
  [AchievementType.Spins]: {
    category: AchievementCategory.GameplayAndActivity,
    title: 'Wheel spins',
    milestones: [
      {
        number: 10,
        icon: WheelBronzeIcon,
        percentage: 95,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 50,
        icon: WheelSilverIcon,
        percentage: 71,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 100,
        icon: WheelGoldIcon,
        percentage: 64,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 500,
        icon: Wheel1Icon,
        percentage: 49,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      { number: 1000, icon: Wheel2Icon, percentage: 36, tooltip: 'Only {percentage} have reached this milestone!' },
      {
        number: 5000,
        icon: Wheel3Icon,
        percentage: 25,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 10000,
        icon: Wheel4Icon,
        percentage: 16,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      { number: 20000, icon: Wheel5Icon, percentage: 9, tooltip: 'You’re among the top {percentage}! A true master!' },
      {
        number: 50000,
        icon: Wheel6Icon,
        percentage: 4,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 100000,
        icon: Wheel7Icon,
        percentage: 1,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 250000,
        icon: Wheel8Icon,
      },
      {
        number: 500000,
        icon: Wheel9Icon,
      },
      {
        number: 750000,
        icon: Wheel10Icon,
      },
      {
        number: 1000000,
        icon: Wheel11Icon,
      },
      {
        number: 1500000,
        icon: Wheel12Icon,
      },
      {
        number: 2000000,
        icon: Wheel13Icon,
      },
      {
        number: 2500000,
        icon: Wheel14Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'spins' : 'spin'}</span> left to unlock this achievement`,
  },
  [AchievementType.Tasks]: {
    category: AchievementCategory.GameplayAndActivity,
    title: 'Quests completed ',
    milestones: [
      {
        number: 10,
        icon: DatabaseServerBronzeIcon,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 50,
        icon: DatabaseServerSilverIcon,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 100,
        icon: DatabaseServerGoldIcon,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 200,
        icon: DatabaseServer1Icon,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      {
        number: 250,
        icon: DatabaseServer2Icon,
        tooltip: 'Only {percentage} have reached this milestone!',
      },
      {
        number: 500,
        icon: DatabaseServer3Icon,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 750,
        icon: DatabaseServer4Icon,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      {
        number: 1000,
        icon: DatabaseServer5Icon,
        tooltip: 'You’re among the top {percentage}! A true master!',
      },
      {
        number: 1250,
        icon: DatabaseServer6Icon,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 1500,
        icon: DatabaseServer7Icon,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 2000,
        icon: DatabaseServer8Icon,
      },
      {
        number: 3000,
        icon: DatabaseServer9Icon,
      },
      {
        number: 4000,
        icon: DatabaseServer10Icon,
      },
      {
        number: 5000,
        icon: DatabaseServer11Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'quests' : 'quest'}</span> left to unlock this achievement`,
  },
  [AchievementType.OnChainTransactions]: {
    category: AchievementCategory.AdvancedPlay,
    title: 'On-chain transactions',
    milestones: [
      {
        number: 1,
        icon: TxBronzeIcon,
        tooltip: '{percentage} of players have reached this achievement!',
      },
      {
        number: 3,
        icon: TxSilverIcon,
        tooltip: 'You joined {percentage} of players! Keep going to reach the higher ranks!',
      },
      {
        number: 5,
        icon: TxGoldIcon,
        tooltip: 'You’re making progress—only {percentage} of players have unlocked this!',
      },
      {
        number: 10,
        icon: Tx1Icon,
        tooltip: 'Halfway to the top! You’re in the top {percentage} of players !',
      },
      {
        number: 15,
        icon: Tx2Icon,
        tooltip: 'Only {percentage} have reached this milestone!',
      },
      {
        number: 25,
        icon: Tx3Icon,
        tooltip: 'Top {percentage} of Dropee\'s finest! You\'re climbing fast!',
      },
      {
        number: 50,
        icon: Tx4Icon,
        tooltip: 'Elite tier—only {percentage} of players have achieved this. Great work!',
      },
      {
        number: 100,
        icon: Tx5Icon,
        tooltip: 'You’re among the top {percentage}! A true master!',
      },
      {
        number: 250,
        icon: Tx6Icon,
        tooltip: 'Incredible—just {percentage} of players have unlocked this achievement!',
      },
      {
        number: 500,
        icon: Tx7Icon,
        tooltip: 'Legendary status! You’re among the top {percentage}!',
      },
      {
        number: 1000,
        icon: Tx8Icon,
      },
      {
        number: 2500,
        icon: Tx9Icon,
      },
      {
        number: 5000,
        icon: Tx10Icon,
      },
      {
        number: 7500,
        icon: Tx11Icon,
      },
      {
        number: 10000,
        icon: Tx12Icon,
      },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'transactions' : 'transaction'}</span> left to unlock this achievement`,
  },
  [AchievementType.Badges]: {
    category: AchievementCategory.DropeeJourney,
    title: 'Badges collected',
    titleTooltipComponent: 'Smash goals and events to earn badges.',
    milestones: [
      { number: 1, icon: ClockBronzeIcon },
      { number: 2, icon: ClockSilverIcon },
      { number: 3, icon: ClockGoldIcon },
      { number: 4, icon: Clock1Icon },
      { number: 5, icon: Clock2Icon },
      { number: 8, icon: Clock3Icon },
      { number: 10, icon: Clock4Icon },
      { number: 15, icon: Clock5Icon },
      { number: 20, icon: Clock6Icon },
      { number: 25, icon: Clock7Icon },
      { number: 30, icon: Clock8Icon },
      { number: 35, icon: Clock9Icon },
      { number: 40, icon: Clock10Icon },
      { number: 45, icon: Clock11Icon },
      { number: 50, icon: Clock12Icon },
      { number: 55, icon: Clock13Icon },
      { number: 60, icon: Clock14Icon },
      { number: 65, icon: Clock15Icon },
      { number: 70, icon: Clock16Icon },
      { number: 75, icon: Clock17Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'badges' : 'badge'}</span> left to unlock this achievement`,
  },
  [AchievementType.Pathways]: {
    category: AchievementCategory.SpecialEvents,
    title: 'Pathway completions',
    titleTooltipComponent: PathwaysCompletedTitleTooltip,
    milestones: [
      { number: 1, icon: PathwayBronzeIcon },
      { number: 5, icon: PathwaySilverIcon },
      { number: 10, icon: PathwayGoldIcon },
      { number: 25, icon: Pathway1Icon },
      { number: 50, icon: Pathway2Icon },
      { number: 100, icon: Pathway3Icon },
      { number: 250, icon: Pathway4Icon },
      { number: 500, icon: Pathway5Icon },
      { number: 1000, icon: Pathway6Icon },
      { number: 1500, icon: Pathway7Icon },
      { number: 2000, icon: Pathway8Icon },
      { number: 2500, icon: Pathway9Icon },
      { number: 3000, icon: Pathway10Icon },
      { number: 5000, icon: Pathway11Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'pathways' : 'pathway'}</span> left to unlock this achievement`,
  },
  [AchievementType.PathwaySteps]: {
    category: AchievementCategory.SpecialEvents,
    title: 'Pathway Steps Claimed',
    titleTooltipComponent: PathwayStepsCompletedTitleTooltip,
    milestones: [
      { number: 5, icon: PathwayStepBronzeIcon },
      { number: 10, icon: PathwayStepSilverIcon },
      { number: 25, icon: PathwayStepGoldIcon },
      { number: 50, icon: PathwayStep1Icon },
      { number: 100, icon: PathwayStep2Icon },
      { number: 250, icon: PathwayStep3Icon },
      { number: 500, icon: PathwayStep4Icon },
      { number: 1000, icon: PathwayStep5Icon },
      { number: 2500, icon: PathwayStep6Icon },
      { number: 5000, icon: PathwayStep7Icon },
      { number: 7500, icon: PathwayStep8Icon },
      { number: 10000, icon: PathwayStep9Icon },
      { number: 15000, icon: PathwayStep10Icon },
      { number: 20000, icon: PathwayStep11Icon },
      { number: 30000, icon: PathwayStep12Icon },
      { number: 40000, icon: PathwayStep13Icon },
      { number: 50000, icon: PathwayStep14Icon },
      { number: 75000, icon: PathwayStep15Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'pathways' : 'pathway'}</span> left to unlock this achievement`,
  },
  [AchievementType.MysteryBoxes]: {
    category: AchievementCategory.AdvancedPlay,
    title: 'Mystery Box Opened',
    milestones: [
      { number: 1, icon: BoxBronzeIcon },
      { number: 5, icon: BoxSilverIcon },
      { number: 10, icon: BoxGoldIcon },
      { number: 25, icon: Box1Icon },
      { number: 50, icon: Box2Icon },
      { number: 100, icon: Box3Icon },
      { number: 200, icon: Box4Icon },
      { number: 350, icon: Box5Icon },
      { number: 500, icon: Box6Icon },
      { number: 750, icon: Box7Icon },
      { number: 1000, icon: Box8Icon },
      { number: 1500, icon: Box9Icon },
      { number: 2000, icon: Box10Icon },
      { number: 2500, icon: Box11Icon },
      { number: 3000, icon: Box12Icon },
    ],
    leftUntilNextMilestoneTooltip: (count) => `<span class="text-green-primary">${formatNumberFullTruncate(count)} ${count > 1 ? 'mystery boxes' : 'mystery box'}</span> left to unlock this achievement`,
  },
}

export const useAchievementsFetcher = () => {
  const isFetching = ref(false)
  const isFetched = ref(false)

  async function fetchAchievements() {
    isFetching.value = true
    try {
      achievements.value = (await api.getAchievements()).stats
      isFetched.value = true
    } catch (e) {
      achievements.value = null
    } finally {
      isFetching.value = false
    }
  }

  return {
    isFetching,
    fetchAchievements,
    isFetched,
    achievements,
    lastAchievements,
  }
}

export const useAchievementsPage = (_checkNewMilestones = true) => {
  const { getMilestone } = useAchievements()
  const { isFetching, fetchAchievements } = useAchievementsFetcher()

  const categoryGroups = computed<
    Record<AchievementCategory, { type: AchievementType; data: typeof achievementCategories[AchievementType] }[]>
  >(() => {
    const achievementsList = achievementCategoryOrder.reduce((acc, category) => {
      acc[category] = []
      return acc
    }, {} as Record<AchievementCategory, {
      type: AchievementType;
      data: typeof achievementCategories[AchievementType]
    }[]>)

    for (const [type, ach] of Object.entries(
      achievementCategories,
    ) as [AchievementType, typeof achievementCategories[AchievementType]][]) {
      if (!ach.hidden) {
        achievementsList[ach.category].push({ type, data: ach })
      }
    }

    return Object.fromEntries(
      Object.entries(achievementsList).filter(([, arr]) => arr.length > 0),
    ) as Record<AchievementCategory, { type: AchievementType; data: typeof achievementCategories[AchievementType] }[]>
  })

  const categoryTitleMap: Record<AchievementCategory, string> = {
    [AchievementCategory.DropeeJourney]: 'Dropee Journey',
    [AchievementCategory.GameplayAndActivity]: 'Gameplay and Activity',
    [AchievementCategory.CardsMastery]: 'Cards Mastery',
    [AchievementCategory.AdvancedPlay]: 'Advanced Play',
    [AchievementCategory.SpecialEvents]: 'Special Events',
    [AchievementCategory.PlaySurge]: 'Play Surge',
  }

  function checkNewMilestones() {
    Object.keys(newlyAchievedMilestones.value).forEach((key: string) => {
      if (!achievements.value) return
      const achievementKey = key as AchievementType
      const lastAchievement = lastAchievements.value?.[achievementKey] ?? 0
      const currentAchievement = achievements.value[achievementKey]
      newlyAchievedMilestones.value[achievementKey] = getMilestone(achievementKey, lastAchievement) !== getMilestone(achievementKey, currentAchievement)
    })
  }

  onBeforeMount(async () => {
    await fetchAchievements()
    if (_checkNewMilestones) {
      checkNewMilestones()
    }
    lastAchievements.value = achievements.value
  })

  return {
    achievements,
    isFetchingAchievements: isFetching,
    categoryGroups,
    categoryTitleMap,
  }
}

export const useAchievements = () => {
  function getMilestone(achievementType: AchievementType, value: number) {
    return achievementCategories[achievementType].milestones.reduce<{
      number: number;
      icon: string;
    }>(
      (last, milestone) =>
        milestone.number <= value ? { number: milestone.number, icon: milestone.icon } : last,
      { number: 0, icon: achievementCategories[achievementType].milestones[0].icon },
    )
  }

  function getLatestMilestone(achievementType: AchievementType) {
    if (!achievements.value) return
    return getMilestone(achievementType, achievements.value[achievementType])
  }

  return {
    achievements,
    newlyAchievedMilestones,
    getMilestone,
    getLatestMilestone,
  }
}

export const useAchievementsTracker = () => {
  const { getMilestone } = useAchievements()
  const { config } = useConfig()
  const { player } = usePlayer()
  const { badgesWithCount } = useBadges()
  const { fortuneWheelState } = useFortuneWheel()
  const { showNewAchievedMilestoneOverlay } = useAchievementsOverlay()

  const totalUpgradedCards = computed(() => Object.values(player.value.upgrades).reduce((total, item) => total + item.level, 0))
  const totalUpgradedCardsAbove15 = computed(() => Object.values(player.value.upgrades).filter(item => item.level >= 15).length)
  const totalUpgradedCardsAbove25 = computed(() => Object.values(player.value.upgrades).filter(item => item.level >= 25).length)
  const totalUpgradedCardsAbove50 = computed(() => Object.values(player.value.upgrades).filter(item => item.level >= 50).length)
  const totalUpgradedCardsAbove100 = computed(() => Object.values(player.value.upgrades).filter(item => item.level >= 100).length)
  const totalUpgradedCardsAbove150 = computed(() => Object.values(player.value.upgrades).filter(item => item.level >= 150).length)
  const totalSpecialCards = computed(() => {
    const specialCardIds = config.value.upgrades.filter(item => item.section === 'Specials').map(item => item.id)
    return Object.entries(player.value.upgrades).filter(([id]) => specialCardIds.includes(id)).length
  })

  const totalDailyCheckins = computed(() => player.value.tasks.dailyCheckin.maxConsecutiveDays ?? 0)
  const totalFriends = computed(() => player.value.referrals.count)
  const totalTasks = computed(() => player.value.tasks.counters['total'] ?? 0)
  const totalSpins = computed(() => fortuneWheelState.value.spins.total)
  const totalBadges = computed(() => badgesWithCount.value.reduce((total, item) => total + item.count, 0))
  const totalTransactions = computed(() => player.value.ecommerce.tonTransactionsCount)
  const totalPathwayCompletionsCount = computed(() => player.value.pathwayEvents.completionsCount)
  const totalPathwayStepsCompletionsCount = computed(() => player.value.pathwayEvents.stepCompletionsCount)
  const totalRevealedMysteryBoxes = computed(() => player.value.ecommerce.revealedMysteryBoxes)
  const totalDailyCombos = computed(() => player.value.challenges.completionsCount.dailyCombo)

  const trackedMilestones = computed((): Partial<Record<AchievementType, number>> => {
    return {
      [AchievementType.DailyCheckinStreaks]: getMilestone(AchievementType.DailyCheckinStreaks, totalDailyCheckins.value).number,
      [AchievementType.CardsUpgrade]: getMilestone(AchievementType.CardsUpgrade, totalUpgradedCards.value).number,
      [AchievementType.CardsAbove15]: getMilestone(AchievementType.CardsAbove15, totalUpgradedCardsAbove15.value).number,
      [AchievementType.CardsAbove25]: getMilestone(AchievementType.CardsAbove25, totalUpgradedCardsAbove25.value).number,
      [AchievementType.CardsAbove50]: getMilestone(AchievementType.CardsAbove50, totalUpgradedCardsAbove50.value).number,
      [AchievementType.CardsAbove100]: getMilestone(AchievementType.CardsAbove100, totalUpgradedCardsAbove100.value).number,
      [AchievementType.CardsAbove150]: getMilestone(AchievementType.CardsAbove150, totalUpgradedCardsAbove150.value).number,
      [AchievementType.SpecialCards]: getMilestone(AchievementType.SpecialCards, totalSpecialCards.value).number,
      [AchievementType.Friends]: getMilestone(AchievementType.Friends, totalFriends.value).number,
      [AchievementType.Tasks]: getMilestone(AchievementType.Tasks, totalTasks.value).number,
      [AchievementType.Badges]: getMilestone(AchievementType.Badges, totalBadges.value).number,
      [AchievementType.OnChainTransactions]: getMilestone(AchievementType.OnChainTransactions, totalTransactions.value).number,
      [AchievementType.Spins]: getMilestone(AchievementType.Spins, totalSpins.value).number,
      [AchievementType.Pathways]: getMilestone(AchievementType.Pathways, totalPathwayCompletionsCount.value).number,
      [AchievementType.PathwaySteps]: getMilestone(AchievementType.PathwaySteps, totalPathwayStepsCompletionsCount.value).number,
      [AchievementType.MysteryBoxes]: getMilestone(AchievementType.MysteryBoxes, totalRevealedMysteryBoxes.value).number,
      [AchievementType.DailyCombo]: getMilestone(AchievementType.DailyCombo, totalDailyCombos.value).number,
    }
  })

  function getNewAchievedMilestoneObject(achievementType: AchievementType, milestoneNumber: number) {
    const milestone = achievementCategories[achievementType].milestones.find(m => m.number === milestoneNumber)
    if (!milestone) return null
    return { achievement: milestone, categoryTitle: achievementCategories[achievementType].title }
  }

  function checkForNewAchievementsOnInit() {
    if (!achievements.value) return
    [AchievementType.DaysSinceOnboarding, AchievementType.Friends].forEach((key: string) => {
      const achievementKey = key as AchievementType
      const lastAchievement = lastAchievements.value?.[achievementKey] ?? 0
      const currentAchievement = achievements.value?.[achievementKey] ?? 0
      if (getMilestone(achievementKey, lastAchievement).number !== getMilestone(achievementKey, currentAchievement).number) {
        newAchievedMilestoneForOverlay.value = getNewAchievedMilestoneObject(achievementKey, getMilestone(achievementKey, currentAchievement).number)
        return
      }
    })
  }

  watch(
    trackedMilestones,
    (newValues, oldValues) => {
      for (const key in newValues) {
        const achievementType = key as AchievementType
        if (newValues[achievementType] !== oldValues[achievementType]) {
          newAchievedMilestoneForOverlay.value = getNewAchievedMilestoneObject(achievementType, newValues[achievementType] as number)
          break
        }
      }
    },
    { deep: true },
  )

  return {
    showNewAchievedMilestoneOverlay,
    newAchievedMilestoneForOverlay,
    getMilestone,
    checkForNewAchievementsOnInit,
  }
}

export const useAchievementsOverlay = () => {
  return {
    isAchievementsOverlayDelayed,
    showNewAchievedMilestoneOverlay: computed(() => !isAchievementsOverlayDelayed.value && !!newAchievedMilestoneForOverlay.value),
  }
}